import React, { useContext } from 'react';
import './languageSelector.css';
import { languageOptions } from '../../languages';
import { LanguageContext } from './language';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function LanguageSelector() {
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);

  // set selected language by calling context method
  const handleLanguageChange = e => userLanguageChange(e.target.value);

  return (
    <>
    <FontAwesomeIcon className="selector-language__icono" icon="globe" />
    <select
      className="selector-idioma"
      onChange={handleLanguageChange}
      value={userLanguage}
    >
      {Object.entries(languageOptions).map(([id, name]) => (
        <option key={id} value={id}>{name}</option>
      ))}
    </select>
    </>
  );
};